import {WicketLocaleOverride} from '../wicket-locale-override';
import {WicketUserDataDictionaryField} from '../wicket-user-data-dictionary-field';

export interface WicketUserDataSection {
  id: string;
  title: string;
  ord: number;
  data: WicketUserDataDictionaryField[];
  locale_override: WicketLocaleOverride<'title', string>[];
}
